"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSAccessoriesComponent = void 0;
const accessories_service_1 = require("../services/accessories.service");
const _ = require("underscore");
const account_service_1 = require("../services/account.service");
const ngx_owl_carousel_o_1 = require("ngx-owl-carousel-o");
class CSAccessoriesComponent {
    constructor(accessoriesService, accountService) {
        this.accessoriesService = accessoriesService;
        this.accountService = accountService;
        this.items = [];
        this.items = [
            {}
        ];
    }
    ngOnInit() {
        this.loop = true;
        this.getAccessoriesDetails();
    }
    getAccessoriesDetails() {
        this.loader = true;
        this.accountService.getDeviceListlInformation().subscribe((res) => {
            this.loader = false;
            this.devicelist = res.deviceDetailList;
            if (this.devicelist === undefined) {
                this.noDeviceMessage = true;
            }
            else {
                this.noDeviceMessage = false;
                this.devicelist = this.getUniqueDeviceList(this.devicelist, 'productId');
                this.productId = this.devicelist[0].productId;
                this.selectDevice(this.productId);
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getUniqueDeviceList(deviceList, property) {
        const newArray = [];
        const tempMap = {};
        for (const i in deviceList) {
            if (deviceList[i] != null) {
                tempMap[deviceList[i][property]] = deviceList[i];
            }
        }
        for (const i in tempMap) {
            if (tempMap[i] !== null) {
                newArray.push(tempMap[i]);
            }
        }
        return newArray;
    }
    selectDevice(productId) {
        this.loading = true;
        this.selectedDevice = _.where(this.devicelist, { productId });
        this.mName = this.selectedDevice[0].manufacturerName;
        this.accessoriesService.getAccessoriesListInformation(productId, this.mName).subscribe((res) => {
            this.loading = false;
            this.accessorieslist = res.accessories;
            // set the row count
            if (window.screen.width <= 768) {
                this.rowCount = 1;
            }
            else {
                this.rowCount = 4;
            }
            // populate UI
            if (this.accessorieslist.length === 0) {
                this.noAccessories = true;
            }
            else {
                this.noAccessories = false;
                // to reduce the possibility of duplicated accessories
                // if the accessory count is less than that of rowCount
                if (this.accessorieslist.length < this.rowCount && window.screen.width > 768) {
                    this.rowCount = this.accessorieslist.length;
                    this.loop = false;
                }
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    nextSlide() {
        this.owlElement.next();
    }
    prevSlide() {
        this.owlElement.prev();
    }
}
exports.CSAccessoriesComponent = CSAccessoriesComponent;
//# sourceMappingURL=accessories.component.js.map